<app-container>
    <div class="page-actions-row">
        <h1 class="page-title">{{ "nav.sub.profile" | translate }}</h1>
        <div class="page-actions">
            <button mat-raised-button color="primary" type="button" [disabled]="form.valid == false && form.pristine == false" (click)="openChangePassword()">
                {{ "changePassword" | translate }}
            </button>
            <button mat-raised-button color="primary" type="button" [disabled]="form.valid == false && form.pristine == false" (click)="onSubmit()">
                {{ "updateUser" | translate }}
            </button>
        </div>
    </div>
    <mat-toolbar>{{ "userDetails" | translate }}</mat-toolbar>
    <mat-card class="card-body p-0">
        <form fxLayout="row wrap" fxLayoutAlign="space-between none" class="form-signin p-15" [formGroup]="form">
            <div fxFlex="48">
                <mat-form-field appearance="outline" floatLabel="always" class="form-group">
                    <mat-label>{{ "firstName" | translate }}</mat-label>
                    <input matInput required type="text" class="form-control" formControlName="usrFirstName">
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrFirstName'].invalid">
                    <mat-error *ngIf="form.controls['usrFirstName'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
            </div>
            <div fxFlex="48">
                <mat-form-field class="form-group" appearance="outline" floatLabel="always">
                    <mat-label>{{ "lastName" | translate }}</mat-label>
                    <input matInput required class="form-control" formControlName="usrLastName">
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrLastName'].invalid">
                    <mat-error *ngIf="form.controls['usrLastName'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
            </div>
            <div fxFlex="48">
                <mat-form-field appearance="outline" floatLabel="always" class="form-group">
                    <mat-label>{{ "userName" | translate }}</mat-label>
                    <input matInput required class="form-control" formControlName="usrUsername">
                    <mat-icon matSuffix>
                        account_circle
                    </mat-icon>
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrUsername'].invalid">
                    <mat-error *ngIf="form.controls['usrUsername'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
            </div>
            <div fxFlex="48">
                <mat-form-field appearance="outline" floatLabel="always" class="form-group">
                    <mat-label>{{ "email" | translate }}</mat-label>
                    <input matInput required class="form-control" formControlName="usrEmail">
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrEmail'].invalid">
                    <mat-error *ngIf="form.controls['usrEmail'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
            </div>
            
        
            <div fxFlex="48">
                <mat-form-field appearance="outline" floatLabel="always" class="form-group">
                    <mat-label>{{ "phone" | translate }}</mat-label>
                    <input matInput class="form-control" formControlName="usrPhone">
                    <mat-icon matSuffix>
                        phone
                    </mat-icon>
                </mat-form-field>
            </div>


            <div fxFlex="48">
                <mat-form-field appearance="outline" floatLabel="always" class="form-group">
                    <mat-label>{{ "timezone" | translate }}</mat-label>
                    <input type="text"
                        required
                        placeholder=""
                        aria-label="Number"
                        matInput
                        formControlName="usrTimeZone"
                        [matAutocomplete]="auto"
                        (focus)="$any($event.target).select()">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onTimezoneSelection($event.option.value)">
                        <mat-option *ngFor="let option of timezones$" [value]="option">
                            <div fxLayoutAlign="space-between center" fxLayout="row">
                              <span> {{ option }}</span>
                            </div>
                          </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <ng-container *ngIf="form.controls['usrTimeZone'].invalid">
                    <mat-error *ngIf="form.controls['usrTimeZone'].errors.required">
                        {{ "required" | translate }}
                    </mat-error>
                </ng-container>
            </div>

            <!--div fxFlex="32">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>{{ "role" | translate }}</mat-label>
                    <mat-select required class="form-control" formControlName="usrIsPrivileged">
                        <mat-option [value]="0">
                            {{ "user" | translate }}
                        </mat-option>
                        <mat-option [value]="1">
                            {{ "admin" | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div-->
            <!--div fxFlex="48">
                <mat-form-field class="form-group" appearance="outline">
                    <mat-label>{{ "login.password" | translate}}</mat-label>
                    <input type="password" matInput placeholder="{{ 'login.password' | translate}}" class="form-control"
                        [type]="isHidden ? 'password' : 'text'" formControlName="usrPassword" autocomplete="off">
                    <mat-icon matSuffix (click)="isHidden = !isHidden">{{ isHidden ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                </mat-form-field>
                <div fxLayout="column" *ngIf="form.controls['usrPassword'].value">
                    <label
                      [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('minlength')  ? 'text-danger' : 'text-success'">
                      <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('minlength') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.8char" | translate }}
                    </label>
                    <label
                      [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasNumber')  ? 'text-danger' : 'text-success'">
                      <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasNumber') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1num" | translate }}
                    </label>
                    <label
                      [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasCapitalCase')  ? 'text-danger' : 'text-success'">
                      <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasCapitalCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1cap" | translate }}
                    </label>
                    <label
                      [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasSmallCase')  ? 'text-danger' : 'text-success'">
                      <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasSmallCase') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1small" | translate }}
                    </label>
                    <label
                      [ngClass]="form.controls['usrPassword'].hasError('required') || form.controls['usrPassword'].hasError('hasSpecialCharacters') ? 'text-danger' : 'text-success'">
                      <i class="material-icons">{{ form.controls['usrPassword'].hasError('required') ||
                        form.controls['usrPassword'].hasError('hasSpecialCharacters') ? 'cancel' :
                        'check_circle' }}</i>
                        {{ "error.1spec" | translate }}
                    </label>
                  </div>
            </div-->
        </form>
    </mat-card>
    <mat-toolbar>{{ "profileImage" | translate }}</mat-toolbar>
    <mat-card class="profile-section-card" height="90px">
            <div class="my-15 text-center">
                <app-profile-image></app-profile-image>
                <div height="40px" class="mb-15"></div>
                <div fxLayout="row" fxLayoutAlign="center center">
                    <app-image-cropper type="profileLogo" fxFlex="50"></app-image-cropper>
                </div>
            </div>
        </mat-card>
        <mat-toolbar id="upgrade" *ngIf="showPricing">{{ "nav.sub.upgrade_plan" | translate }}</mat-toolbar>
        <mat-card class="mat-card-box_plans" style="display: block;" *ngIf="showPricing">
            <div *ngIf="isOGAdmin === 1">
                <div class="content_box_admin_name">
                    If you are interested in changing your Tier, please get in touch with the owner of this account: <div class="admin_name">{{ OGAdminFullName }}</div>
                </div>
            </div>
            <div class="container_plans">
                <div class="box_plan {{height_box}}" [ngClass]="{'current-plan': tierID === 1}" >
                    <div *ngIf="tierID === 1" class="current-plan-label"><p class="current-plan-label-text">{{ "currentTier" | translate }}</p></div>
                    <div class="box_plan_img"><img src="./../../assets/Freemium_plan_Logo.svg" alt="freemium" class="box_plan_icon" /></div>
                    <div class="box_plan_title {{height_plan_title}}">{{ "freemium" | translate }}</div>
                    <div class="box_list">
                        <ul class="box_plan_list">
                            <li class="box_plan_list_main">{{ "upTo" | translate }} 50 {{ "products" | translate }}</li>
                            <li>1 {{ "location" | translate }}</li>
                            <li>1 {{ "user" | translate }}</li>
                            <li>{{ "emailCountSheets" | translate }}</li>
                            <li>{{ "emailReports" | translate }}</li>
                        </ul>
                    </div>
                    <div class="box_actions">
                        <button [ngClass]="tierID === 1 || isOGAdmin === 1 ? 'box_action_button_inactive' : 'box_action_button_active'" (click)="openChargebeePlan(1)">{{text_tier_1}}</button>
                    </div>
                </div>
                <div class="box_plan {{height_box}}" [ngClass]="{'current-plan': tierID === 2}" >
                    <div *ngIf="tierID === 2" class="current-plan-label"><p class="current-plan-label-text">{{ "currentTier" | translate }}</p></div>
                    <div class="box_plan_img"><img src="./../../assets/people.svg" alt="tier1" class="box_plan_icon" /></div>
                    <div class="box_plan_title {{height_plan_title}}">{{ "tier1" | translate }}- $99/{{ "mo" | translate }} </div>
                    <div class="box_list">
                        <ul class="box_plan_list">
                            <li class="box_plan_list_main">{{ "upTo" | translate }} 500 {{ "products" | translate }}</li>
                            <li>1 {{ "location" | translate }}</li>
                            <li>5 {{ "users" | translate }}</li>
                            <li>{{ "emailCountSheets" | translate }}</li>
                            <li>{{ "emailReports" | translate }}</li>
                            <li>{{ "multipleCountMethods" | translate }}</li>
                            <li>{{ "customizableBranding" | translate }}</li>
                        </ul>
                    </div>
                    <div class="box_actions">
                        <button [ngClass]="tierID === 2 || isOGAdmin === 1 ? 'box_action_button_inactive' : 'box_action_button_active'" (click)="openChargebeePlan(2)">{{text_tier_2}}</button>
                    </div>
                </div>
                <div class="box_plan {{height_box}}" [ngClass]="{'current-plan': tierID === 3}">
                    <div *ngIf="tierID === 3" class="current-plan-label"><p class="current-plan-label-text">{{ "currentTier" | translate }}</p></div>
                    <div class="box_plan_img"><img src="./../../assets/lightbulb.svg" alt="tier2" class="box_plan_icon" /></div>
                    <div class="box_plan_title {{height_plan_title}}">{{ "tier2" | translate }}- $299/{{ "mo" | translate }} </div>
                    <div class="box_list">
                        <ul class="box_plan_list">
                            <li class="box_plan_list_main">500 - 5000 {{ "products" | translate }}</li>
                            <li>1 {{ "location" | translate }}</li>
                            <li>25 {{ "users" | translate }}</li>
                            <li>{{ "emailCountSheets" | translate }}</li>
                            <li>{{ "emailReports" | translate }}</li>
                            <li>{{ "multipleCountMethods" | translate }}</li>
                            <li>{{ "customizableBranding" | translate }}</li>
                        </ul>
                    </div>
                    <div class="box_actions">
                        <button [ngClass]="tierID === 3 || isOGAdmin === 1 ? 'box_action_button_inactive' : 'box_action_button_active'" (click)="openChargebeePlan(3)">{{text_tier_3}}</button>
                    </div>
                </div>
                <div class="box_plan {{height_box}}" [ngClass]="{'current-plan': tierID === 4}">
                    <div *ngIf="tierID === 4" class="current-plan-label"><p class="current-plan-label-text">{{ "currentTier" | translate }}</p></div>
                    <div class="box_plan_img"><img src="./../../assets/lightening.svg" alt="tier3" class="box_plan_icon" /></div>
                    <div class="box_plan_title {{height_plan_title}}">{{ "tier3" | translate }} - {{ "contactUs" | translate }}</div>
                    <div class="box_list">
                        <ul class="box_plan_list">
                            <li class="box_plan_list_main">{{ "over" | translate }} 5000 {{ "products" | translate }}</li>
                            <li>1 {{ "location" | translate }}</li>
                            <li>{{ "unlimited" | translate }} {{ "users" | translate }}</li>
                            <li>{{ "emailCountSheets" | translate }}</li>
                            <li>{{ "emailReports" | translate }}</li>
                            <li>{{ "multipleCountMethods" | translate }}</li>
                            <li>{{ "customizableBranding" | translate }}</li>
                        </ul>
                    </div>
                    <div class="box_actions">
                        <button [ngClass]="tierID === 4 || isOGAdmin === 1 ? 'box_action_button_inactive' : 'box_action_button_active'" (click)="openChargebeePlan(4)">{{text_tier_4}}</button>
                    </div>
                </div>
            </div>
        </mat-card>
        <mat-toolbar *ngIf="showPricing">
            {{ "subscriptionHistory" | translate }}
            <button mat-icon-button (click)="toggleCardCollapse()">
                <mat-icon>{{ cardCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
            </button>
        </mat-toolbar>
        <mat-card *ngIf="showPricing">
            <mat-expansion-panel [expanded]="!cardCollapsed">
                <table mat-table [dataSource]="historySubscription" matSort width="100%" class="custom-table">
                    <ng-container *ngFor="let c of columns" [matColumnDef]="c.field">
                        <ng-container>
                            <th mat-header-cell *matHeaderCellDef class="custom-header">
                            {{c.header}}
                            </th>
                        </ng-container>
                        <td mat-cell *matCellDef="let element" class="custom-cell">
                            {{element[c.field]}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="getColumnDefs()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getColumnDefs();"></tr>
                </table>
            </mat-expansion-panel>
        </mat-card>
</app-container>